import { ShippedOrdersData } from './ShippedOrdersCard.types'

export const SHIPPED_ORDERS_MOCK: ShippedOrdersData[] = [
  {
    employee: 'Lukas Loscheider',
    id: 1,
    name: 'Apple iPhone 12 Pro  256GB Black 4.7 128GB 3G',
    status: '',
  },
  {
    employee: 'Lukas Loscheider',
    id: 2,
    name: 'Apple iPhone 12 Pro  256GB Black 4.7 128GB 3G',
    status: '',
  },
  {
    employee: 'Lukas Loscheider',
    id: 3,
    name: 'Apple iPhone 12 Pro  256GB Black 4.7 128GB 3G',
    status: '',
  },
  {
    employee: 'Lukas Loscheider',
    id: 4,
    name: 'Apple iPhone 12 Pro  256GB Black 4.7 128GB 3G',
    status: '',
  },
  {
    employee: 'Lukas Loscheider',
    id: 5,
    name: 'Apple iPhone 12 Pro  256GB Black 4.7 128GB 3G',
    status: '',
  },
  {
    employee: 'Lukas Loscheider',
    id: 6,
    name: 'Apple iPhone 12 Pro  256GB Black 4.7 128GB 3G',
    status: '',
  },
  {
    employee: 'Lukas Loscheider',
    id: 7,
    name: 'Apple iPhone 12 Pro  256GB Black 4.7 128GB 3G',
    status: '',
  },
  {
    employee: 'Lukas Loscheider',
    id: 8,
    name: 'Apple iPhone 12 Pro  256GB Black 4.7 128GB 3G',
    status: '',
  },
  {
    employee: 'Lukas Loscheider',
    id: 9,
    name: 'Apple iPhone 12 Pro  256GB Black 4.7 128GB 3G',
    status: '',
  },
  {
    employee: 'Lukas Loscheider',
    id: 10,
    name: 'Apple iPhone 12 Pro  256GB Black 4.7 128GB 3G',
    status: '',
  },
]
